import React from 'react';
import { cn } from '../../lib/cn';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
  containerClassName?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, hint, className, containerClassName, id, ...props }, ref) => {
    const fieldId = id || props.name;
    return (
      <div className={cn('flex flex-col gap-1.5', containerClassName)}>
        {label && (
          <label htmlFor={fieldId} className="text-sm font-medium text-foreground">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={fieldId}
          className={cn(
            'min-h-[96px] w-full rounded-lg border bg-surface-1 px-3 py-2.5 text-base text-foreground',
            'placeholder:text-foreground-subtle transition-colors duration-150',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 disabled:opacity-60',
            error ? 'border-danger focus-visible:ring-danger/30' : 'border-border hover:border-border-strong',
            className
          )}
          aria-invalid={!!error}
          {...props}
        />
        {error ? (
          <span className="text-sm text-danger">{error}</span>
        ) : hint ? (
          <span className="text-sm text-foreground-muted">{hint}</span>
        ) : null}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
